module.exports = __webpack_public_path__ + "static/media/flood block.ea17d4be.jpg";